var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("« Back to home / 回首頁")])],1),_c('v-row',[_c('v-col',[_c('v-card',[_c('entry-list',{attrs:{"entries":_vm.entries}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }